window.Campaign = {

    opts    : {
        hoyaYouReplacedClass    : 'hoya-and-you-initiated',
        openSelectorClass: 'lang-selector-open'
    },

    $win: $(window),
    $anchorMenuWrapper: $('.anchor-menu-wrapper'),
    $anchorLinks: $('.anchor-links'),
    $campaignPageContainer: $('.campaign-page-container'),
    $textColumnOnImageBackgroundBlocks: $('.text-column-on-image-block'),

    modalTimer: 0,

    init: function () {

        var self = this,
            $body = $('body');

        if (!self.$campaignPageContainer.length) {
            return;
        }

        if (self.$anchorMenuWrapper.length) {
            
            // Language dropdown
            $(".languages-dropdown-text").click(function (e) {
                $(".languages-dropdown-content").toggleClass("active");
            });

            // Select language item
            $(".languages-dropdown-content span").click(function () {
                $(".languages-dropdown-content span").removeClass("selected");
                $(this).addClass("selected");
                window.Campaign.selectLanguages(this);

                var url = $(".languages-dropdown-text").data("language");
                window.location.href = url;
            });

            // Open language modal
            $(".lang-selector-anchor").click(function (e) {
                if ($body.hasClass('lang-selector-open')) {
                    self.closeLangModal();
                }else {
                    self.openLangModal();
                }
                e.preventDefault();
            });

            // Stop body click event when clicking on the modal
            $('.campaign-language-selector-overlay').on('click', function(e){
                e.stopPropagation();
            });

            // Close language modal
            $(".language-close a.close-language-selector").click(function () {
                self.closeLangModal();
            });

            $(".languages-button-select").click(function () {
                var url = $(".languages-dropdown-text").data("language");
                window.location.href = url;
            });
            
            $('.scroll-to-anchor').on('click', function (e) {
                e.preventDefault();
                var anchorId = $(this).data('anchor-id');
                if (anchorId) {
                    window.Helpers.scrollTo('#' + anchorId, $('.navbar').height());
                }
            });

            // Enable ESC key
            $(document).keyup(function(e) {
                if (e.keyCode === 27) {
                    if ($('body').hasClass(self.opts.openSelectorClass)) {
                        self.closeLangModal();
                    }
                }
            });
        }

        $('.text-on-image-block .text-container  *, .block .header-column *').each(function () {
            var $this = $(this);
            var html = $this.html().replace('HOYA+YOU', '<span class="hoya-hoya">HOYA</span>+<span class="hoya-you">YOU</span>');
            html = html.replace('+', '<span class="hoya-plus">+</span>');
            $this.html(html);

        });
        
        $body.addClass(self.opts.hoyaYouReplacedClass);
    },

    openLangModal: function(){
        var self    = this,
            $body   = $('body');

        $body
            .off('click')
            .addClass(self.opts.openSelectorClass);


        // Create click outside event 250ms after modal has been opened
        clearTimeout(self.modalTimer);
        modalTimer = setTimeout(function(){
            $body.on('click', function(){
                self.closeLangModal();
            });
        }, 250)

    },

    closeLangModal: function(){
        var self    = this,
            $body   = $('body');

        clearTimeout(self.modalTimer);
        $body
            .removeClass(self.opts.openSelectorClass)
            .off('click');
    },

    selectLanguages: function (language) {
        $(".languages-dropdown-text").data("language", $(language).data("language"));
        $(".languages-dropdown-text span").html($(language).html());
        $(".languages-dropdown-content").removeClass("active");
    },

    UpdateStartIndex: function(pageId) {
        let startIndex = $("#startIndex_" + pageId).val();
        $("#startIndex_" + pageId).val(parseInt(startIndex) + 6);
    },
    ShowLoadMoreButton: function(contentGuid) {
         $.get("/api/advice/ShowLoadMoreButton",
            {
                languageCode: $("html").attr("lang"),
                contentId: contentGuid,
                startIndex: $("#startIndex_" + contentGuid).val()
            },
            function (data) {
                if (!data) {
                    $("#button_" + contentGuid).hide();
                }
            }
        );
    }
};
